import type { Theme, ThemeConfig, ThemePackage } from '../types/theme';
import { ThemeCompact } from './theme.compact';
import { ThemeDefault } from './theme.default';
import { ThemeMaterial } from './theme.material';

export const DEFAULT_THEME = 'default';

export const allowedThemes: Theme[] = [
  DEFAULT_THEME,
  'material',
  'compact',
  'darkMaterial',
  'darkCompact',
];
export default class ThemeService {
  private currentTheme: ThemePackage;
  private customRowSize = 0;

  get theme() {
    return this.currentTheme;
  }

  get rowSize() {
    return this.customRowSize || this.currentTheme.defaultRowSize;
  }

  set rowSize(size: number) {
    this.customRowSize = size;
  }

  constructor(cfg: ThemeConfig) {
    this.customRowSize = cfg.rowSize;
    this.register('default');
  }

  register(theme: Theme) {
    const parsedTheme = getTheme(theme);
    switch (parsedTheme) {
      case 'material':
      case 'darkMaterial':
        this.currentTheme = new ThemeMaterial();
        break;
      case 'compact':
      case 'darkCompact':
        this.currentTheme = new ThemeCompact();
        break;
      default:
        this.currentTheme = new ThemeDefault();
        break;
    }
  }
}


export function getTheme(theme?: string | null): Theme {
  if (theme && allowedThemes.indexOf(theme as Theme) > -1) {
    return theme as Theme;
  }
  return DEFAULT_THEME;
}